import * as dev from './environment';
import * as prod from './environment.prod';
import * as staging from './environment.staging';
import * as staging_uat from './environment.staging_uat';
import * as prod_pwc from './environment.prod_pwc';

// Config is imported in index.html
const AppConfig = JSON.parse(localStorage.getItem('grip-config'));


export const environments: {[envName: string]: Partial<typeof dev.environment>} = {
  dev: dev.environment,
  prod: prod.environment,
  staging: staging.environment,
  staging_uat: staging_uat.environment,
  prod_pwc: prod_pwc.environment,
};

// Select a base environment
// In case an env is missing in config.json we use "dev"
// "dev" gets transpiled into whichever environment was used with "ng build"
let selectedEnvironment = environments[AppConfig?.environment || dev];
// Variables in config.json override variables in the selected base environment
export const environment = {...selectedEnvironment, ...AppConfig};
